import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComputerChip = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n            .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "computer-chip" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 3.75,
			y: 3.75,
			width: 16.5,
			height: 16.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 3.75,
			x2: 12,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 3.75,
			x2: 6.75,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 3.75,
			x2: 17.25,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 22.5,
			x2: 12,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 22.5,
			x2: 6.75,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 22.5,
			x2: 17.25,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 22.5,
			y1: 12,
			x2: 20.25,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 22.5,
			y1: 17.25,
			x2: 20.25,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 22.5,
			y1: 6.75,
			x2: 20.25,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 12,
			x2: 1.5,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 17.25,
			x2: 1.5,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 6.75,
			x2: 1.5,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 6.75,
			y: 6.75,
			width: 10.5,
			height: 10.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.25,
			y1: 14.25,
			x2: 12,
			y2: 14.25
		})
	]
});
export default SvgComputerChip;
